import styled from '@emotion/styled';

import COLORS from '$variables/colors';
import { spacing } from '$variables/theme';

// eslint-disable-next-line import/prefer-default-export
export const HeaderItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px ${spacing.medium};
  border-bottom: 1px solid ${COLORS.grey};
`;

export const RightDecorationDesktop = styled.div`
  display: flex;
  margin-left: ${spacing.xSmall};
`;

export const MobileOverlay = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
`;

export const RelativeContainer = styled.div`
  position: relative;
`;
